import React, { useState, useRef, useEffect } from 'react';
import ClientProvider from '../../Various/ClientProvider';
import Form from "@rjsf/core";
import { ItemsTableDefault, ItemsTableOther } from '../../Various/ItemsTable/ItemsTable'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactJson from 'react-json-view'
import envs from '../../../envs'
import ProjectPathSelectorWidget from "../../Various/ProjectPathSelectorWidget";
export default function WorkspaceBatchJobs() {
  const wsProvider = React.useContext(ClientProvider);
  const [batchJobsOverview, setBatchJobsOverview] = useState({})
  const [batchJobDetails, setBatchJobDetails] = useState(null)
  const [sortColumns, setSortColumns] = useState([])
  const [sortColumns2, setSortColumns2] = useState([])
  const [sortColumns3, setSortColumns3] = useState([])
  const [batchJobTabs, setBatchJobTabs] = wsProvider.useStateVarGlobal("batchJobTabs", 0)
  const [filterFormData, setFilterFormData] = wsProvider.useStateVarGlobal("filterFormDataBatch", {
    batchJobName: 'CrawlerRunParallel'
  })

  var [filterColumnsItems, setFilterColumnsItems] = useState({})
  var [filterColumnsCommands, setFilterColumnsCommands] = useState({})

  let onlyLocal = []
  if (envs.host === "localhost") {
    onlyLocal.push("DownloadClientOutputFromAws")
  }



  const [schemaDefinition, setSchemaDefinition] = useState(
    {
      schema: {
        type: 'object',
        properties: {
          batchJobName: {
            enum: [],
            title: 'batchJobName',
            type: 'string'
          },
          batchJobId: {
            "title": "batchJobId",
            "type": "string",
            "enum": []
          },
          filterStatus: {
            "title": "filterStatus",
            "type": "string",
            "enum": ["SUBMITTED", "RUNNING", "SUCCEEDED", "FAILED"]
          }
        },
        required: ["batchJobName"]
      },
      uiSchema: {
        'ui:order': [
          'batchJobName',
          'batchJobId',
          'filterStatus'
        ]
      }
    })

  useEffect(
    () => {
      wsProvider.ws.waitForSocketAndSend(
        {
          action: "list_batch_jobs",
          options: {}
        },
        (response) => {
          let batchJobs = (envs.host === "localhost") ? response["data"] : response["data"].filter(job => !onlyLocal.includes(job))

          setSchemaDefinition(
            {
              schema: {
                type: 'object',
                properties: {
                  batchJobName: {
                    enum: batchJobs.map(x => x["module_name"]),
                    enumNames: batchJobs.map(x => x["display_name"]),
                    title: 'batchJobName',
                    type: 'string'
                  },
                  batchJobId: {
                    "title": "batchJobId",
                    "type": "string",
                    "enum": []
                  },
                  filterStatus: {
                    "title": "filterStatus",
                    "type": "string",
                    "enum": ["SUBMITTED", "RUNNING", "SUCCEEDED", "FAILED"]
                  }
                },
                required: ["batchJobName"]
              },
              uiSchema: {
                'ui:order': [
                  'batchJobName',
                  'batchJobId',
                  'filterStatus'
                ]
              }
            }
          )
        }
      )
    }, []
  )

  useEffect(() => {
    loadBatchJobsOverview()
  }, []);

  useEffect(() => {
    if (Object.keys(batchJobsOverview).length > 0) {
      const schemaNew = {
        ...schemaDefinition,
        schema: {
          ...schemaDefinition.schema,
          properties: {
            ...schemaDefinition.schema.properties,
            /*
            batchJobName: {
              ...schemaDefinition.schema.properties.batchJobName,
              enum: Object.keys(batchJobsOverview["batchJobs"])
            },
            */
            batchJobId: {
              ...schemaDefinition.schema.properties.batchJobId,
              enum: (filterFormData.batchJobName && batchJobsOverview["batchJobs"][filterFormData.batchJobName]) ? batchJobsOverview["batchJobs"][filterFormData.batchJobName].map(x => x["batchJobId"]) : [],
              enumNames: (filterFormData.batchJobName && batchJobsOverview["batchJobs"][filterFormData.batchJobName]) ? batchJobsOverview["batchJobs"][filterFormData.batchJobName].map(x => { let date = new Date(); date.setTime(x["batchJobId"]); return date.toLocaleString() }) : [],
            }
          }
        }
      }
      setSchemaDefinition(schemaNew)
    }
  }, [batchJobsOverview, filterFormData.batchJobName]);

  useEffect(() => {
    loadBatchJobDetails()
  }, [filterFormData.batchJobId])

  useEffect(() => {
    // Register Callback
    // Return is the cleanup function
    return wsProvider.registerBatchJobUpdateHandler("workspaceBatchJobs", handleBatchJobUpdate)
  }, [filterFormData.batchJobId, filterFormData.batchJobName])

  const refreshBatchJobsOverview = () => {
    loadBatchJobsOverview()
  }

  const handleBatchJobUpdate = (data) => {
    // console.log("handleBatchJobUpdate")
    // console.log(data)
    //Check if this job is opened:
    if (data["batchJobId"] === filterFormData.batchJobId && data["batchJobName"] === filterFormData.batchJobName) {

      if (data["level"] === "batchJobItemCommand") {
        setBatchJobDetails(x => {
          if (!x || !x.commands)
            return x
          const batchJobDetailsNew = {
            ...x,
            time: data.time,
            commands: [
              ...x.commands
            ]
          }
          const index = batchJobDetailsNew.commands.findIndex(x => (x.path === data.stats.path))
          batchJobDetailsNew.commands[index] = data.stats
          return batchJobDetailsNew
        })
      } else if (data["level"] === "batchJobItem") {
        setBatchJobDetails(x => {
          const batchJobDetailsNew = {
            ...x,
            time: data.time,
          }

          if (x && "items" in x) {
            batchJobDetailsNew.items = [...x.items]
          } else {
            batchJobDetailsNew.items = []
          }

          const index = batchJobDetailsNew.items.findIndex(x => (x.path === data.stats.path))
          batchJobDetailsNew.items[index] = data.stats
          return batchJobDetailsNew
        })
      } else if (data["level"] === "batchJob") {
        setBatchJobDetails(x => {
          if (data.stats['progress_succeeded']) {
            data.stats['progress_succeeded'] = data.stats['progress_succeeded'] * 100 + '%'
          }
          if (data.stats['progress_failed']) {
            data.stats['progress_failed'] = data.stats['progress_failed'] * 100 + '%'
          }
          const batchJobDetailsNew = {
            ...x,
            time: data.time,
            job: data.stats
          }
          return batchJobDetailsNew
        })
      }
    }
  }

  const loadBatchJobsOverview = (extraCallback) => {
    wsProvider.ws.waitForSocketAndSend({
      action: "getBatchJobsOverview",
      options: {}
    }, (response) => {
      console.log("overview response", response)
      setBatchJobsOverview(response)
      if (extraCallback) {
        extraCallback()
      }
    })
  }

  const loadBatchJobDetails = () => {
    if (!filterFormData.batchJobId)
      return

    wsProvider.ws.waitForSocketAndSend({
      action: "getBatchJobDetails",
      options: {
        batchJobId: filterFormData.batchJobId,
        batchJobName: filterFormData.batchJobName
      }
    }, (response) => {
      setBatchJobDetails(response)
    })
  }

  const deleteJob = () => {
    wsProvider.ws.waitForSocketAndSend({
      action: "deleteBatchJob",
      options: {
        batchJobId: filterFormData.batchJobId,
        batchJobName: filterFormData.batchJobName
      }
    }, (response) => {
      refreshBatchJobsOverview()
      setFilterFormData(filterFormData => {
        const filterFormDataNew = {
          ...filterFormData
        }
        delete filterFormDataNew.batchJobId
        return filterFormDataNew
      })
    })
  }

  const deleteJobAll = () => {
    wsProvider.ws.waitForSocketAndSend({
      action: "deleteAllBatchJob",
      options: {
        batchJobName: filterFormData.batchJobName
      }
    }, (response) => {
      refreshBatchJobsOverview()
      setFilterFormData({
        batchJobName: filterFormData.batchJobName
      })
    })
  }

  const filterChangeHandler = (data) => {
    setFilterFormData(data.formData)
  }

  const addFieldForceStopBtn = (data) => {
    if (data === undefined) {
      return data
    }
    return [
      ...data.map(x => {
        if (x) {
          x["forceStopBtn"] = ["RUNNING", "SUBMITTED"].includes(x["status"]) ? "STOP" : ""
        }
        return x
      })
    ]
  }

  const addFieldReattemptBtn = (data) => {
    if (data === undefined) {
      return data
    }
    return [
      ...data.map(x => {
        if (x) {
          x["reattemptBtn"] = "REATTEMPT" // ["SUCCEEDED", "FAILED"].includes(x["status"]) ? "REATTEMPT" : ""
        }
        return x
      })
    ]
  }

  const addFieldRestartFromCommandBtn = (data) => {
    if (data === undefined) {
      return data
    }
    
    // First, enrich commands with itemIndex and commandIndex by parsing their paths
    // Paths are in format "itemIndex.commandIndex" (DOT separator) or "itemIndex/commandIndex" (SLASH)
    // NOTE: Items may not have nested commands arrays, so we parse directly from path
    data.forEach((cmd) => {
      if (!cmd) return
      
      // Skip if already has both indices
      if (cmd._cachedItemIndex !== undefined && cmd._cachedCommandIndex !== undefined) {
        return
      }
      
      // Parse from path - try DOT separator first (most common format)
      if (cmd.path && typeof cmd.path === 'string') {
        const dotParts = cmd.path.split('.')
        if (dotParts.length >= 2) {
          cmd._cachedItemIndex = dotParts[0]
          cmd._cachedCommandIndex = dotParts[1]
          return
        }
        // Fallback: try SLASH separator
        const slashParts = cmd.path.split('/')
        if (slashParts.length >= 2) {
          cmd._cachedItemIndex = slashParts[0]
          cmd._cachedCommandIndex = slashParts[1]
          return
        }
      }
    })
    
    // Fallback: Try to match by searching through items (only if items have commands arrays)
    if (batchJobDetails && batchJobDetails.items && Array.isArray(batchJobDetails.items)) {
      data.forEach((cmd, cmdArrayIdx) => {
        if (!cmd) return
        
        // Skip if already has both indices
        if (cmd._cachedItemIndex !== undefined && cmd._cachedCommandIndex !== undefined) {
          return
        }
        
        // Search through items to find which item contains this command
        let matched = false
        for (const batchItem of batchJobDetails.items) {
          if (batchItem.commands && Array.isArray(batchItem.commands)) {
            const cmdIdx = batchItem.commands.findIndex((itemCmd, itemCmdIdx) => {
              // Match by path (most reliable)
              if (itemCmd.path && cmd.path && itemCmd.path === cmd.path) {
                return true
              }
              // Match by object reference
              if (itemCmd === cmd) {
                return true
              }
              // Match by key fields
              if (itemCmd.status === cmd.status && 
                  (itemCmd.name === cmd.name || cmd.commandName === cmd.commandName)) {
                return true
              }
              return false
            })
            
            if (cmdIdx !== -1) {
              // Found it! Store the indices for later use
              cmd._cachedItemIndex = String(batchItem.path)
              cmd._cachedCommandIndex = String(cmdIdx)
              matched = true
              break
            }
          }
        }
      })
    }
    
    // Group commands by item to find the first failed command per item
    const commandsByItem = {}
    data.forEach((cmd, idx) => {
      if (!cmd) return
      
      // Determine item identifier - use cached value if available
      let itemId = null
      if (cmd._cachedItemIndex !== undefined) {
        itemId = String(cmd._cachedItemIndex)
      } else if (cmd.itemIndex !== undefined && cmd.itemIndex !== null) {
        itemId = String(cmd.itemIndex)
      } else if (cmd.itemPath !== undefined && cmd.itemPath !== null) {
        itemId = String(cmd.itemPath)
      } else if (cmd.path && typeof cmd.path === 'string') {
        const pathParts = cmd.path.split('/')
        if (pathParts.length >= 2) {
          itemId = pathParts[0]
        }
      }
      
      // If we can't determine item, use a default group
      if (itemId === null) {
        itemId = '_default'
      }
      
      if (!commandsByItem[itemId]) {
        commandsByItem[itemId] = []
      }
      commandsByItem[itemId].push({ cmd, idx })
    })
    
    // Find the first failed command index for each item
    // Sort by commandIndex to ensure we get the actual first failed command
    const firstFailedIndexByItem = {}
    Object.keys(commandsByItem).forEach(itemId => {
      const itemCommands = commandsByItem[itemId]
      // Sort by commandIndex if available, otherwise use array index
      const sortedCommands = [...itemCommands].sort((a, b) => {
        const aIdx = a.cmd._cachedCommandIndex !== undefined ? parseInt(a.cmd._cachedCommandIndex) : 
                     (a.cmd.commandIndex !== undefined ? parseInt(a.cmd.commandIndex) : a.idx)
        const bIdx = b.cmd._cachedCommandIndex !== undefined ? parseInt(b.cmd._cachedCommandIndex) : 
                     (b.cmd.commandIndex !== undefined ? parseInt(b.cmd.commandIndex) : b.idx)
        return aIdx - bIdx
      })
      const firstFailed = sortedCommands.find(({ cmd }) => cmd.status === 'FAILED')
      if (firstFailed) {
        // Store the original array index of the first failed command
        firstFailedIndexByItem[itemId] = firstFailed.idx
      }
    })
    
    return [
      ...data.map((x, idx) => {
        if (x) {
          let canRestart = false
          
          // Determine item identifier for this command
          let itemId = null
          if (x._cachedItemIndex !== undefined) {
            itemId = String(x._cachedItemIndex)
          } else if (x.itemIndex !== undefined && x.itemIndex !== null) {
            itemId = String(x.itemIndex)
          } else if (x.itemPath !== undefined && x.itemPath !== null) {
            itemId = String(x.itemPath)
          } else if (x.path && typeof x.path === 'string') {
            const pathParts = x.path.split('/')
            if (pathParts.length >= 2) {
              itemId = pathParts[0]
            }
          }
          if (itemId === null) {
            itemId = '_default'
          }
          
          const status = x["status"]
          
          // SUCCEEDED commands: show button
          if (status === "SUCCEEDED") {
            canRestart = true
          }
          // SUBMITTED commands: don't show button
          else if (status === "SUBMITTED") {
            canRestart = false
          }
          // FAILED commands: only show for the first failed command in the item
          else if (status === "FAILED") {
            canRestart = (firstFailedIndexByItem[itemId] === idx)
          }
          // RUNNING commands: show button (keep existing behavior)
          else if (status === "RUNNING") {
            canRestart = true
          }
          
          // Don't show restart button for awsbatch compute environment
          const engine = batchJobDetails?.batchJobDefinition?.batchJobOptions?.engine
          if (engine === "awsbatch") {
            canRestart = false
          }
          
          x["restartFromCommandBtn"] = canRestart ? "RESTART FROM HERE" : ""
        }
        return x
      })
    ]
  }

  const clickHandler_batchJobOverview = (item, column, index, itemOrig) => {
    if (column === "forceStopBtn" && item["forceStopBtn"] === "STOP") {
      wsProvider.ws.waitForSocketAndSend({
        action: "stopBatchJob",
        options: {
          batchJobId: filterFormData.batchJobId,
          batchJobName: filterFormData.batchJobName
        }
      }, (response) => {
        // alert("stopBatchJob: " + filterFormData.batchJobId)
      })
    } else {
      wsProvider.toLog(item[column], true)
    }
  }

  const clickHandler_batchJobOverviewItem = (item, column, index, itemOrig) => {
    if (column === "forceStopBtn" && item["forceStopBtn"] === "STOP") {
      wsProvider.ws.waitForSocketAndSend({
        action: "stopBatchJobItem",
        options: {
          batchJobId: filterFormData.batchJobId,
          batchJobName: filterFormData.batchJobName,
          itemIndex: item["path"]
        }
      }, (response) => {
        //  alert("stopBatchJobItem: " + filterFormData.batchJobId + "/" + item["path"])
      })
    } else if (column === "reattemptBtn") {
      wsProvider.ws.waitForSocketAndSend({
        action: "manualReattemptBatchJobItem",
        options: {
          batchJobId: filterFormData.batchJobId,
          batchJobName: filterFormData.batchJobName,
          itemIndex: item["path"]
        }
      }, (response) => {
        //  alert("stopBatchJobItem: " + filterFormData.batchJobId + "/" + item["path"])
      })

    } else {
      wsProvider.toLog(item[column], true)
    }
  }
  const clickHandler_batchJobOverviewItemCommand = (item, column, index, itemOrig) => {
    if (column === "restartFromCommandBtn" && item["restartFromCommandBtn"] === "RESTART FROM HERE") {
      // Extract itemIndex and commandIndex from the command
      // The most reliable way is to search through batchJobDetails.items to find which item contains this command
      let itemIndex = null
      let commandIndex = null

      // Primary strategy: Parse path directly - paths are in format "itemIndex.commandIndex" (DOT separator)
      if (item.path && typeof item.path === 'string') {
        // Try DOT separator first (e.g., "0.0", "1.1")
        const dotParts = item.path.split('.')
        if (dotParts.length >= 2) {
          itemIndex = dotParts[0]
          commandIndex = dotParts[1]
        } else {
          // Fallback: try SLASH separator (e.g., "0/2")
          const slashParts = item.path.split('/')
          if (slashParts.length >= 2) {
            itemIndex = slashParts[0]
            commandIndex = slashParts[1]
          }
        }
      }
      
      // Secondary strategy: Use cached indices if available (set when adding restart button)
      if ((itemIndex === null || commandIndex === null) && item._cachedItemIndex !== undefined && item._cachedCommandIndex !== undefined) {
        itemIndex = String(item._cachedItemIndex)
        commandIndex = String(item._cachedCommandIndex)
      }
      
      // Tertiary strategy: Search through items to find which item contains this command
      // NOTE: This may not work if items.commands arrays are empty (commands only in flat list)
      if ((itemIndex === null || commandIndex === null) && batchJobDetails && batchJobDetails.items && Array.isArray(batchJobDetails.items)) {
        for (const batchItem of batchJobDetails.items) {
          if (batchItem.commands && Array.isArray(batchItem.commands)) {
            // Try to find this command in the item's commands array
            // Match by path (most reliable)
            let cmdIdx = -1
            
            // First try: exact path match
            if (item.path) {
              cmdIdx = batchItem.commands.findIndex(cmd => cmd.path === item.path)
            }
            
            // Second try: if path doesn't match, try matching by path structure
            // Commands might have paths like "itemIndex/commandIndex" or just "commandIndex"
            if (cmdIdx === -1 && item.path) {
              const itemPathStr = String(batchItem.path)
              // Check if command path starts with item path
              if (item.path.startsWith(itemPathStr + '/')) {
                // Extract commandIndex from path
                const pathAfterItem = item.path.substring(itemPathStr.length + 1)
                cmdIdx = batchItem.commands.findIndex(cmd => {
                  if (cmd.path) {
                    const cmdPathParts = cmd.path.split('/')
                    const cmdPathAfterItem = cmdPathParts.length > 1 ? cmdPathParts.slice(1).join('/') : cmdPathParts[0]
                    return cmdPathAfterItem === pathAfterItem
                  }
                  return false
                })
                // If still not found, try using the pathAfterItem as commandIndex
                if (cmdIdx === -1) {
                  const cmdIdxNum = parseInt(pathAfterItem)
                  if (!isNaN(cmdIdxNum) && cmdIdxNum >= 0 && cmdIdxNum < batchItem.commands.length) {
                    cmdIdx = cmdIdxNum
                  }
                }
              }
            }
            
            // Third try: match by comparing object identity or key fields
            // This handles cases where the command object in the flat list is the same reference
            if (cmdIdx === -1) {
              cmdIdx = batchItem.commands.findIndex(cmd => {
                // Direct object reference match
                if (cmd === item || cmd === itemOrig) {
                  return true
                }
                // Match by multiple identifying fields
                const fieldsMatch = (
                  cmd.status === item.status &&
                  (cmd.name === item.name || cmd.commandName === item.commandName) &&
                  cmd.path === item.path
                )
                return fieldsMatch
              })
            }
            
            if (cmdIdx !== -1) {
              // Found the command in this item
              itemIndex = String(batchItem.path)
              commandIndex = String(cmdIdx)
              break
            }
          }
        }
      }

      // Fallback strategy 1: Check for explicit fields
      if ((itemIndex === null || commandIndex === null)) {
        if (item.itemIndex !== undefined && item.itemIndex !== null && itemIndex === null) {
          itemIndex = String(item.itemIndex)
        }
        if (item.commandIndex !== undefined && item.commandIndex !== null && commandIndex === null) {
          commandIndex = String(item.commandIndex)
        }
        if (item.itemPath !== undefined && item.itemPath !== null && itemIndex === null) {
          itemIndex = String(item.itemPath)
        }
      }

      // Fallback strategy 2: Parse path if it's structured like "itemIndex/commandIndex"
      if ((itemIndex === null || commandIndex === null) && item.path && typeof item.path === 'string') {
        const pathParts = item.path.split('/')
        if (pathParts.length >= 2) {
          // Path is like "0/2" (itemIndex/commandIndex)
          // Try both orders in case it's reversed
          if (itemIndex === null && commandIndex === null) {
            // Both missing - assume first is itemIndex, second is commandIndex
            itemIndex = pathParts[0]
            commandIndex = pathParts[1]
          } else if (itemIndex === null) {
            itemIndex = pathParts[0]
          } else if (commandIndex === null) {
            commandIndex = pathParts[1]
          }
        } else if (pathParts.length === 1) {
          // Path might be just the commandIndex or itemIndex
          // Try to use it as commandIndex if we have itemIndex, or vice versa
          if (itemIndex !== null && commandIndex === null) {
            commandIndex = pathParts[0]
          } else if (itemIndex === null && commandIndex !== null) {
            itemIndex = pathParts[0]
          } else {
            // Neither is set - try to find itemIndex by searching, then use this as commandIndex
            // Or use this as itemIndex and search for commandIndex
            // This is ambiguous, so we'll skip it and rely on other strategies
          }
        }
      }

      // Debug logging to help diagnose issues
      if (itemIndex === null || commandIndex === null) {
        console.log("Command restart - extraction failed", {
          item,
          itemOrig,
          itemIndex,
          commandIndex,
          batchJobDetailsItems: batchJobDetails?.items?.map(it => ({
            path: it.path,
            commandsCount: it.commands?.length
          })),
          commandPath: item.path,
          commandStatus: item.status
        })
      }

      // If we have both itemIndex and commandIndex, proceed with restart
      if (itemIndex !== null && commandIndex !== null) {
        // Find the item to show which commands will be preserved
        // NOTE: Items don't have nested commands arrays, so get from flat commands list
        let itemCommands = []
        if (batchJobDetails && batchJobDetails.commands && Array.isArray(batchJobDetails.commands)) {
          // Filter commands by itemIndex - parse path to get itemIndex
          itemCommands = batchJobDetails.commands.filter(cmd => {
            if (!cmd || !cmd.path) return false
            // Parse path - try DOT separator first (e.g., "0.0", "1.1")
            const dotParts = cmd.path.split('.')
            if (dotParts.length >= 2) {
              return dotParts[0] === itemIndex
            }
            // Fallback: try SLASH separator
            const slashParts = cmd.path.split('/')
            if (slashParts.length >= 2) {
              return slashParts[0] === itemIndex
            }
            // Fallback: check explicit fields
            if (cmd.itemIndex !== undefined) return String(cmd.itemIndex) === itemIndex
            if (cmd.itemPath !== undefined) return String(cmd.itemPath) === itemIndex
            return false
          })
          // Sort by commandIndex (parse from path)
          itemCommands.sort((a, b) => {
            const aParts = a.path.split('.')
            const bParts = b.path.split('.')
            const aIdx = aParts.length >= 2 ? parseInt(aParts[1]) : (aParts.length >= 1 ? parseInt(aParts[0]) : 0)
            const bIdx = bParts.length >= 2 ? parseInt(bParts[1]) : (bParts.length >= 1 ? parseInt(bParts[0]) : 0)
            return aIdx - bIdx
          })
        }

        // Perform restart directly without confirmation dialog
        wsProvider.ws.waitForSocketAndSend({
          action: "manualReattemptBatchJobItemFromCommand",
          options: {
            batchJobId: filterFormData.batchJobId,
            batchJobName: filterFormData.batchJobName,
            itemIndex: itemIndex,
            commandIndex: commandIndex
          }
        }, (response) => {
          // Optionally reload details after restart
          // loadBatchJobDetails()
        })
      } else {
        // If we can't determine itemIndex or commandIndex, show an error
        alert(`Unable to determine itemIndex or commandIndex for this command.\nPath: ${item.path}\nPlease check the command structure.`)
        console.error("Command restart failed - missing itemIndex or commandIndex", {
          item,
          itemIndex,
          commandIndex,
          batchJobDetails
        })
      }
    } else {
      wsProvider.toLog(item[column], true)
    }
  }

  const renderBatchJobHeader = () => {
    if (batchJobDetails && filterFormData.batchJobId && "items" in batchJobDetails)
      return (
        <ItemsTableDefault
          tableData={addFieldForceStopBtn([batchJobDetails["job"]])}
          sortColumns={sortColumns2}
          setSortColumns={setSortColumns2}
          time={batchJobDetails["time"]}
          extraClass="batchJobOverview"
          key={filterFormData.batchJobId}
          clickHandler={clickHandler_batchJobOverview}
        />
      )
    return null
  }

  const filterByStatus = (data) => {
    if (filterFormData.filterStatus)
      return data.filter(x => x["status"] === filterFormData.filterStatus)
    return data
  }

  var tableData_batchJobOverviewItem = []
  var tableData_batchJobOverviewItemCommand = []
  if (batchJobDetails && filterFormData.batchJobId) {
    let items = batchJobDetails["items"]
    items = addFieldForceStopBtn(items)
    items = addFieldReattemptBtn(items)
    tableData_batchJobOverviewItem = filterByStatus(items)
    let commands = batchJobDetails.commands
    commands = addFieldRestartFromCommandBtn(commands)
    tableData_batchJobOverviewItemCommand = filterByStatus(commands)
  }

  return (
    <div className="row">
      <div className="col-12 workspaceTop">
        <div className='flex_header'>
          <div className='header'>
            <div className='row'>
              <div className='col-6'>
                <Form
                  className="Form_BatchJobOverview"
                  schema={schemaDefinition["schema"]}
                  uiSchema={schemaDefinition["uiSchema"]}
                  formData={filterFormData}
                  onChange={filterChangeHandler}
                />
              </div>
              <div className='col-6'>
                <button
                  onClick={refreshBatchJobsOverview}
                  className="btn btn-primary btn-sm refreshClients"
                >
                  <i className="bi bi-arrow-clockwise"> Overview</i>
                </button>
                <button
                  onClick={loadBatchJobDetails}
                  className="btn btn-primary btn-sm refreshClients"
                >
                  <i className="bi bi-arrow-clockwise"> Job</i>
                </button>
                {filterFormData.batchJobId &&
                  <button
                    onClick={deleteJob}
                    className="btn btn-primary btn-sm refreshClients"
                  >
                    <i className="bi bi-trash"> Delete</i>
                  </button>
                }
                {filterFormData.batchJobName &&
                  <button
                    onClick={deleteJobAll}
                    className="btn btn-primary btn-sm refreshClients"
                  >
                    <i className="bi bi-trash"> Delete All</i>
                  </button>
                }
              </div>
            </div>
          </div>
          <div className='content'>
            {filterFormData.batchJobName &&
              <Tabs
                selectedIndex={batchJobTabs}
                onSelect={setBatchJobTabs}
                className={"react-tabs height100 flex_header batchJobTabs"}
              >
                <TabList className="react-tabs__tab-list header">
                  <Tab>Create Batch-Job</Tab>
                  {batchJobDetails && filterFormData.batchJobId && tableData_batchJobOverviewItem && tableData_batchJobOverviewItemCommand &&
                    <>
                      <Tab>Items ({tableData_batchJobOverviewItem.length})</Tab>
                      <Tab>Commands ({tableData_batchJobOverviewItemCommand.length})</Tab>
                      <Tab>Definition</Tab>

                    </>
                  }
                </TabList>
                <TabPanel className="content">
                  <CreateBatchJob
                    batchJobName={filterFormData.batchJobName}
                    setFilterFormData={setFilterFormData}
                    key={filterFormData.batchJobName + "_" + filterFormData.batchJobId}
                    loadBatchJobsOverview={loadBatchJobsOverview}
                    setBatchJobTabs={setBatchJobTabs}
                    batchJobDetails={batchJobDetails}
                  />
                </TabPanel>
                {batchJobDetails && filterFormData.batchJobId &&
                  <>
                    <TabPanel className="content">
                      <div className='flex_header'>
                        <div className='header'>
                          {renderBatchJobHeader()}
                        </div>
                        <div className='content'>
                          {(batchJobDetails && filterFormData.batchJobId && "items" in batchJobDetails) &&
                            <>
                              <ItemsTableDefault
                                tableData={tableData_batchJobOverviewItem}
                                sortColumns={sortColumns}
                                setSortColumns={setSortColumns}
                                time={batchJobDetails["time"]}
                                key={filterFormData.batchJobId}
                                extraClass="batchJobOverviewItem"
                                clickHandler={clickHandler_batchJobOverviewItem}
                                filterColumns={filterColumnsItems}
                                setFilterColumns={setFilterColumnsItems}
                              />
                            </>
                          }
                        </div>
                      </div>

                    </TabPanel>
                    <TabPanel className="content">
                      <div className='flex_header'>
                        <div className='header batchJobHeader'>
                          {renderBatchJobHeader()}
                        </div>
                        <div className='content'>
                          {(batchJobDetails && filterFormData.batchJobId && "commands" in batchJobDetails) &&
                            <>
                              <ItemsTableDefault
                                tableData={tableData_batchJobOverviewItemCommand}
                                sortColumns={sortColumns3}
                                setSortColumns={setSortColumns3}
                                time={batchJobDetails["time"]}
                                key={filterFormData.batchJobId}
                                extraClass="batchJobOverviewItemCommand"
                                clickHandler={clickHandler_batchJobOverviewItemCommand}
                                filterColumns={filterColumnsCommands}
                                setFilterColumns={setFilterColumnsCommands}
                              />
                            </>
                          }
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel className="content">
                      <BatchJobDefinitionPanel
                        key={filterFormData.batchJobId}
                        batchJobDefinition={batchJobDetails.batchJobDefinition}
                      />
                    </TabPanel>
                  </>
                }
              </Tabs>
            }
          </div>
        </div>
      </div>
    </div >
  )
}

function CreateBatchJob({ batchJobName, setFilterFormData, loadBatchJobsOverview, setBatchJobTabs, batchJobDetails }) {
  const wsProvider = React.useContext(ClientProvider);
  const [schemaDefinition, setSchemaDefinition] = useState(null)
  const [formData, setFormData] = useState((batchJobDetails && batchJobDetails.batchJobDefinition) ? batchJobDetails.batchJobDefinition.batchJobOptions : {})

  const changeFormDataHandler = (data) => {
    setFormData(data.formData)
  }

  const widgets = {
    projectpathselector: ProjectPathSelectorWidget,
  };

  const batchJobInitHandler = () => {

    const batchJobOptions = {
      ...formData
    }

    if (!("projectPathSelector" in batchJobOptions)) {
      batchJobOptions["projectPathSelector"] = {
        "project": wsProvider.selectedProjectId,
        // "selectionType": "single",
        // "selectionValue": this.context.clientSelected,
        // "maxClients": 0
      }
    }

    wsProvider.ws.waitForSocketAndSend({
      action: "batchJobInit",
      options: {
        batchJobName,
        batchJobOptions: batchJobOptions,
        project_id: wsProvider.selectedProjectId
      }
    }, (response) => {
      loadBatchJobsOverview(() => {
        setFilterFormData(filterFormData => ({
          ...filterFormData,
          batchJobId: response.batchJobId
        }))
        setBatchJobTabs(1)  // was 1
      })
    })
  }

  useEffect(() => {
    wsProvider.ws.waitForSocketAndSend({
      action: "getBatchJobSchemaDefinition",
      options: { batchJobName, project_id: wsProvider.selectedProjectId }
    }, (response) => {
      setSchemaDefinition(response)
    })
  }, []);


  if (schemaDefinition) {
    return (
      <Form
        className="Form_BatchJobConfig"
        schema={schemaDefinition["schema"]}
        uiSchema={schemaDefinition["uiSchema"]}
        formData={formData}
        onChange={changeFormDataHandler}
        onSubmit={batchJobInitHandler}
        omitExtraData={true}
        widgets={widgets}
      >
        <button type="submit" className='btn btn-info'>RUN</button>
      </Form>
    )
  }

  return null
}

function BatchJobDefinitionPanel({ batchJobDefinition }) {
  return (
    <ReactJson
      src={batchJobDefinition}
      theme="monokai"
      indentWidth={2}
      displayDataTypes={false}
      key={batchJobDefinition.batchJobId}
      collapsed={2}
    />
  )
}